import React, {memo, useState} from 'react';

function Socials() {
  const [showEmail, setShowEmail] = useState(false);

  return (
    <footer>
      <div id="socials-container" aria-label="Links to my socials">
        <span id="mail-tooltip" aria-label="email" className={(showEmail ? "" : "invisible")} tabIndex={0}>
          <p>knylundkai[at]gmail[dot]com</p>
          <div></div>
        </span>
        <i className='fa fa-envelope fa-2x' onClick={() => setShowEmail(!showEmail)}></i>
        <a href="https://github.com/KaiNylund" aria-label="github" target="_blank" rel="noreferrer">
          <i className='fa-brands fa-github fa-2x'></i>
        </a>
        <a href="https://scholar.google.com/citations?user=8SpcESUAAAAJ&hl=en" aria-label="google scholar" target="_blank" rel="noreferrer">
          <i className='ai ai-google-scholar ai-2x'></i>
        </a>
        <a href="https://bsky.app/profile/kainylund.bsky.social" aria-label="bluesky" target="_blank" rel="noreferrer">
          <i className="fa-brands fa-bluesky fa-2x"></i>
        </a>
        <a href={process.env.PUBLIC_URL + "/nylund_cv_07-2026.pdf"} aria-label="CV" target="_blank" rel="noreferrer">
          CV
        </a>
      </div>
    </footer>
  );
}

export default memo(Socials);